exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".aflac-quoter form{background-color:unset;border:none;padding:0}.aflac-quoter form .basic-info{background-color:#fff;border:2px solid #cdcdcd;border-radius:6px;padding:1rem 1.5rem}.aflac-quoter form .aflac-quote-results{background-color:#fff;border:2px solid #cdcdcd;border-radius:6px;padding-top:0px !important;padding-bottom:0px !important}.aflac-quoter form .aflac-quote-results p{font-size:.85rem}.aflac-quoter form .aflac-quote-results h3{text-align:left !important;font-size:1.5rem !important}.aflac-quoter form .aflac-quote-results .quote-row{padding:0 7.5px}.aflac-quoter form .aflac-quote-results .quote-row .card-wrapper{padding:0 7.5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Supplemental/steps/Quoter.scss
// module id = 7849
// module chunks = 13